import { createTheme } from "@mui/material/styles";
import { COLORS } from "constant";

export let theme = createTheme({
  typography: {
    fontFamily: ["Atten Round New"].join(","),
    // fontFamily: ["Como"].join(","),
  },
});

theme = {
  ...theme,
  components: {
    MuiDrawer: {
      styleOverrides: {
        paper: {
          // width:  196,
          width: 230, // default width for mobile screens
          [theme.breakpoints.up("md")]: {
            width: 196, // width for medium screens and up
          },

          "::-webkit-scrollbar": {
            display: "none !important",
          },
          borderRight: `1px solid ${COLORS.black.light}`,
          "& .MuiListItem-root": {
            padding: "5px 0px 5px 0px",

            "& .MuiListItemButton-root": {
              paddingTop: "15px",
              paddingBottom: "15px",

              color: COLORS.gray.main,
              "& .MuiListItemText-root": {
                margin: "0px 20px",
                // "& .MuiTypography-root": {
                //   textAlign: "start",
                // },
              },
              // "&:hover": {
              //   background: COLORS.gradient.main,
              // },
            },
            "& .MuiListItemButton-root.Mui-selected": {
              background: COLORS.gradient.main,
              borderLeft: `7.76px solid ${COLORS.primary.hard}`,
            },
          },
        },
      },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 99,
          textTransform: "none",
        },
        contained: {
          fontWeight: 700,
          fontSize: "16px",
          boxShadow: "none",
          padding: "15px 0px",
          color: COLORS.black.main,
          backgroundColor: COLORS.primary.main,
          "&:active": {
            boxShadow: "none",
          },
          "&:hover": {
            boxShadow: "none",
          },
        },
        outlined: {
          fontWeight: 700,
          fontSize: "16px",
          padding: "3px 10px",
          border: `2px solid ${COLORS.primary.light}`,
          "&.MuiButton-inActive": {
            color: COLORS.dark.light,
            border: `2px solid ${COLORS.dark.light}`,
          },
        },
      },
    },

    MuiInput: {
      styleOverrides: {
        underline: {
          "&:before": {
            borderBottom: "none",
          },
          "&:after": {
            borderBottom: "none",
          },
        },
        input: {
          borderRadius: 8,
          padding: "15px",
        },
      },
    },

    MuiTab: {
      styleOverrides: {
        root: {
          "&.MuiTab-users-menu": {
            display: "flex",
            fontSize: "16px",
            fontWeight: "700",
            padding: "10px 60px",
            textTransform: "none",
            color: COLORS.dark.light,
            borderBottom: `2px solid ${COLORS.gray.thin}`,
          },
        },
      },
    },
  },
};

export default theme;
